
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { GrowthIndicator } from './GrowthIndicator';
import { MetricConfig, MonthlyMetric } from './types';

interface MonthlyMetricCardProps {
  metric: MonthlyMetric | null;
  config: MetricConfig;
  loading?: boolean;
}

export const MonthlyMetricCard: React.FC<MonthlyMetricCardProps> = ({
  metric,
  config,
  loading = false
}) => {
  const { title, icon: Icon, valueFormatter, color } = config;

  if (loading) {
    return (
      <Card className="h-full">
        <CardContent className="p-4">
          <h3 className="text-lg font-semibold flex items-center mb-2">
            <Icon className={`h-5 w-5 mr-2 ${color}`} />
            {title}
          </h3>
          <div className="space-y-2">
            <div className="h-8 bg-muted rounded animate-pulse w-2/3"></div>
            <div className="h-4 bg-muted rounded animate-pulse w-1/2"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!metric) {
    return (
      <Card className="h-full">
        <CardContent className="p-4">
          <h3 className="text-lg font-semibold flex items-center mb-2">
            <Icon className={`h-5 w-5 mr-2 ${color}`} />
            {title}
          </h3>
          <div className="text-2xl font-bold text-muted-foreground">
            Нет данных
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="h-full">
      <CardContent className="p-4">
        <h3 className="text-lg font-semibold flex items-center mb-2">
          <Icon className={`h-5 w-5 mr-2 ${color}`} />
          {title}
        </h3>
        <div className="text-2xl font-bold mb-2">
          {valueFormatter(metric.value)}
        </div>
        {metric.growth !== undefined && (
          <GrowthIndicator 
            growth={metric.growth} 
            label={config.growthLabel}
          />
        )}
      </CardContent>
    </Card>
  );
};
